import { ActionTypes, ClearRouter, SaveItems, SaveRequested } from './types';

import { RequestedItem, RouteItem } from '@/types/route';

const saveRouterItems = (payload: RouteItem[] | []): SaveItems => ({
  type: ActionTypes.SAVE_ITEMS,
  payload,
});
const saveRequestedItems = (payload: RequestedItem[] | []): SaveRequested => ({
  type: ActionTypes.SAVE_REQUESTED,
  payload,
});
const clearRouter = (): ClearRouter => ({
  type: ActionTypes.CLEAR_ROUTER,
});

export { saveRouterItems, saveRequestedItems, clearRouter };
